module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceSelectStoreLanguageRenderModule",
    "path": "front/piece-select-store-language-render.module"
  },

  "definition": {
    "name": "PieceSelectStoreLanguageDefinition",
    "type": "select-store-language",
    "description": "País e idioma",
    "group": "Components",
    "availablePlatforms": ["web"],
    "fields": [
      {
        "name": "detectLanguage",
        "label": "Detectar idioma automáticamente",
        "type": "boolean",
        "mandatory": true
      },
      {
        "name": "noNavigation",
        "label": "Mantener url actual al cambiar",
        "type": "boolean",
        "mandatory": true
      }, {
        "name": "comboSelector",
        "label": "Selección mediante combo",
        "type": "boolean",
        "mandatory": true
      }, {
        "name": "allowCountryChange",
        "label": "Selección de país",
        "type": "boolean",
        "mandatory": true
      }
    ]
  }
};
